<template>
    <div class="field grid">
        <div class="col-12">
            <div class="flex justify-content-between p-ai-center connectorsHeader">
                <h5 class="m-0" data-v-772a23d3="">{{ translated('conectorstitle') }}</h5>
                <Button v-if="!isMinisterstvo" :label="translated('addconnectorbutton')" class="p-button-raised p-button-error addConnector p-button-sm" icon="pi pi-plus" @click="AddNewConnector" />               
            </div>
        </div>
         
        <div v-for="conn in Connectors" :key="conn.DateAdded" class="col-12 conectorCard" >
            <Connector :conn="conn" :submitted="submitted" :key="conn.DateAdded" @removeConnector="removeConnectorLocal" /> 
            <!--          
            <span> {{ conn.CableAttached }}</span>
            <span> {{ conn.MaxPowerAtSocket }}</span>
            <span> {{ conn.Voltage }}</span>
            <span> {{ conn.VoltageSpecified }}</span>
            -->
        </div>        
    </div>  
</template>

<script>
import { computed } from "vue";
import store from "@/store";
import Connector from "@/components/Connector.vue";

export default {
    //inject: ['$v'],
    //setup: () => ({ v$: useVuelidate() }),
    components: { Connector },
    props: ['Connectors','submitted'],    
    emits: ["addNewConnector","removeConnector"],
    data() {
        return {
            translated: computed(() => store.getters.getTranslate),
        }
    },
    mounted() {
        //console.log('KLIČEM MOUNTED Connectors CONTROL !!!!')
        //console.log(this.Connectors);
        
    },    
    computed: {
		isMinisterstvo() {
            return (this.$store.getters.isInRole("MAdmin") || this.$store.getters.isInRole("MUser"));
            //return (this.$store.getters.getRole=="MAdmin" || this.$store.getters.getRole=="MUser");
			// return true;
        }
    },    
    methods: {
        removeConnectorLocal(tmpData) {
            //console.log('RemoceConnectorLocal');
            //console.log(tmpData);
            this.$emit('removeConnector', tmpData)             
        },
        AddNewConnector() {
            var d = new Date();
            var n = d.getTime();

            const newConn = {
                Id: '00000000-0000-0000-0000-000000000000',
                CableAttached: true,
                MaxPowerAtSocket: 10,
                Voltage: 48,
                VoltageSpecified: 48,
                DateAdded: n,
                ChargingInterface: null,
                CableType: null
            }

            this.$emit('addNewConnector', newConn) 
/*
console.log(this.Connectors);
            if(!this.Connectors){
                console.log('kreiram nov arra');
                this.Connectors = new Array();
                console.log(this.Connectors);
            }
                

            this.Connectors.push(newConn);

            console.log(this.Connectors);
            */
            
        }
    }
}
</script>

<style scoped>
.connectorsHeader {
    background: #f8f9fa;
    padding: 10px;
}
button.addConnector {
    width:150px !important;
}
.conectorCard .card {
    border: 1px solid #dee2e6;
    margin-top: 10px;
}

</style>